// extracted by mini-css-extract-plugin
export var container = "matching-offers-section-module--container--3wPzG";
export var offer = "matching-offers-section-module--offer--1kynl";
export var logo = "matching-offers-section-module--logo--3TKM-";
export var disclaimer = "matching-offers-section-module--disclaimer--1821_";
export var wrapper = "matching-offers-section-module--wrapper--qKQ1W";